/**
 * Установка на главный экран (docs/08-mobile-roadmap.md, M7).
 *
 * Service worker (public/sw.js) регистрируется только в собранном
 * приложении и только в защищённом контексте: на dev-сервере он кэшировал
 * бы модули Vite, а по http://IP браузер его и не разрешит.
 */

import { BASE_PATH } from "@/shared/api/basePath";

export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !window.isSecureContext || !("serviceWorker" in navigator)) return;
  const scope = `${BASE_PATH}/`;
  // После загрузки страницы: регистрация не должна отнимать сеть у бандла.
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(`${scope}sw.js`, { scope }).catch(() => {
      // Без воркера приложение работает как обычный сайт — это не ошибка.
    });
  });
}

/**
 * Цвет строки состояния и полосы браузера — цвет поверхности текущей темы.
 *
 * Тема меняется атрибутом data-theme на <html> (uiSlice) или, у темы
 * «Как в системе», настройкой ОС. Следим за обоими, а не за состоянием
 * React: тема действует и на странице входа, вне каркаса приложения.
 */
export function watchThemeColor(): void {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (meta === null) return;
  const root = document.documentElement;

  const apply = () => {
    const color = getComputedStyle(root).getPropertyValue("--color-surface").trim();
    if (color !== "") meta.content = color;
  };

  apply();
  new MutationObserver(apply).observe(root, { attributes: true, attributeFilter: ["data-theme"] });
  window.matchMedia?.("(prefers-color-scheme: dark)").addEventListener("change", apply);
}
